module.exports = __webpack_public_path__ + "img/easywallet.4a47b8d0.png";